import {AfterContentChecked, AfterContentInit, Component, ElementRef, Input, OnInit, QueryList} from '@angular/core';

@Component({
  selector: 'dcp-limited-html',
  templateUrl: './limited-html.component.html',
  styleUrls: ['./limited-html.component.scss']
})
export class LimitedHtmlComponent implements OnInit, AfterContentInit, AfterContentChecked {

  @Input() showMoreOption = true;
  @Input() initiallyExtended = false;
  @Input() maxHeight = 255;
  /**
   * Optional list of other LimitedHtmlComponent that should collapse when this is opened.
   * The list mey contain the current component.
   */
  @Input() componentsToToggle: LimitedHtmlComponent[] | QueryList<LimitedHtmlComponent>;
  /**
   * Unique id for adobe analytics.
   */
  @Input() uniqueId: string;

  contentMaxHeight: string;
  extended = false;
  limitExceeded = true;

  constructor(public elt: ElementRef) {
  }

  get exceedsLimit() {
    const overflownElement: HTMLElement = this.elt.nativeElement.querySelector('div.overflow-hidden');
    return this.extended || this.isOverflown(overflownElement);
  }

  ngOnInit(): void {
    this.extended = this.initiallyExtended;
  }

  ngAfterContentInit(): void {
    if (!this.exceedsLimit) {
      this.setContentMaxHeight();
    }
  }

  ngAfterContentChecked(): void {
    this.limitExceeded = this.exceedsLimit;
  }

  /**
   * Checks if the content is higher than the element passed in.
   *
   * @param element to check if its being overflown.
   */
  isOverflown(element: any): boolean {
    return element.scrollHeight > this.maxHeight;
  }

  toggleExtend(): void {
    this.extended = !this.extended;
    this.setContentMaxHeight();
  }

  setContentMaxHeight(): void {
    if (this.extended) {
      this.contentMaxHeight = 'none';
      this.toggleSiblings(this.componentsToToggle);
    } else {
      this.unextend();
    }
  }

  /**
   * Collapses this component.
   */
  public unextend(): void {
    this.extended = false;
    this.contentMaxHeight = this.maxHeight + 'px';
  }

  /**
   * Finds this component in a list of LimitedHtmlComponent.
   * The component is being identified by its position.
   */
  public getCurrentComponentIndex(componentsToToggle: LimitedHtmlComponent[] | QueryList<LimitedHtmlComponent>): number {
    let counter: number = 0;
    for (const cToToggle of componentsToToggle) {
      if (this.uniqueId === cToToggle.uniqueId) {
        return counter;
      }
      counter++;
    }
    return -1;
  }

  /**
   * Collapses opened LimitedHtmlComponent that are present in list passed in as componentsToToggle.
   * This LimitedHtmlComponent is not being closed.
   *
   * @param componentsToToggle List of LimitedHtmlComponents that should be collapsed when this component is opened.
   */
  toggleSiblings(componentsToToggle: LimitedHtmlComponent[] | QueryList<LimitedHtmlComponent>): void {
    if (componentsToToggle) {
      let counter: number = 0;
      const currentComponentIndex: number = this.getCurrentComponentIndex(componentsToToggle);
      for (const cToToggle of componentsToToggle) {
        if (counter !== currentComponentIndex) {
          cToToggle.unextend();
        }
        counter++;
      }
    }
  }

  /**
   * Adds a uuid to the html-id to make sure it is unique.
   * The id is needed for adobe tracking.
   */
  generateId(): string {
    return 'limited-html-component-' + this.uniqueId + '-' + (this.extended ? 'less' : 'more');
  }
}
